import { CalloutKeyEnum } from './YourInsights';

const STORAGE_KEY = 'dismissed-insights';

export const getDismissedCallouts = (): CalloutKeyEnum[] => {
  const stored = window.sessionStorage.getItem(STORAGE_KEY);
  const parsed = stored ? JSON.parse(stored) : [];
  return Array.isArray(parsed) ? parsed : [];
};

export const saveDismissedCallouts = (callouts: CalloutKeyEnum[]): void => {
  window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(callouts));
};

export const clearDismissedCallouts = (): void => {
  window.sessionStorage.removeItem(STORAGE_KEY);
};
